<template>
  <div class="flex-1 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <app-logo/>
      <h2 class="text-center text-3xl leading-9 font-extrabold text-gray-900">
        {{$t('forgotPassword.title')}}
      </h2>
    </div>

    <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
      <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
        <form @submit.prevent="submit">
          <div>
            <label for="email" class="block text-sm font-medium leading-5 text-gray-700">
              {{$t('login.placeholders.email')}}
            </label>
            <div class="mt-1 rounded-md">
              <fg-input v-model="form.email"
                        addon-left-icon="nc-icon nc-single-02"
                        v-validate="modelValidations.email"
                        :name="$t('forgotPassword.placeholders.email')"
                        :error="getError($t('forgotPassword.placeholders.email'))"
                        id="email"
                        :placeholder="$t('forgotPassword.placeholders.email')">
              </fg-input>
            </div>
          </div>

          <div class="mt-6">
            <span class="block w-full rounded-md shadow-sm">
              <base-button type="default"
                           native-type="submit"
                           :loading="loading"
                           block
                           class="mb-3">
                {{$t('login.submit')}}
              </base-button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  import { Card } from 'src/components'
  import AppFooter from './layout/AppFooter'
  import AuthService from 'src/services/AuthService'
  import AppLogo from './AppLogo'

  export default {
    components: {
      Card,
      AppFooter,
      AppLogo
    },
    data () {
      return {
        displaySuccessMessage: false,
        loading: false,
        form: {
          email: ''
        },
        modelValidations: {
          email: {
            required: true,
            email: true
          }
        }
      }
    },
    methods: {
      async submit () {
        let result = await this.$validator.validateAll()
        if (!result) return
        try {
          this.loading = true
          await AuthService.forgotPassword(this.form)
          this.$notify({type: 'success', message: this.$t('forgotPassword.successMessage')})
          this.$router.push({name: 'login'})
        } catch (e) {
          this.$notify({type: 'danger', message: this.$t('forgotPassword.errorMessage')})
        } finally {
          this.loading = false
        }
      }
    }
  }
</script>
